import { render } from "./CompositionTabs.vue?vue&type=template&id=afd87134"
import script from "./CompositionTabs.vue?vue&type=script&lang=js"
export * from "./CompositionTabs.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__